var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{style:(_vm.pageStyle),attrs:{"id":"landing-page"}},[_c('module',{class:{
			raised: _vm.isRaised,
			angled: _vm.isAngled,
			shadow: _vm.isShadow,
			outlined: _vm.isOutlined,
		},style:(_vm.rootStyle),attrs:{"id":"root","data":_vm.root}},_vm._l((_vm.content),function(module){return _c('module',{key:module.id,attrs:{"data":module}})}),1),(_vm.$store.getters.expired)?_c('expired-dialog',{attrs:{"title":_vm.settings.expireTitle,"text":_vm.settings.expireText}}):_vm._e(),(!_vm.$store.getters.started)?_c('expired-dialog',{attrs:{"title":_vm.settings.startTitle,"text":_vm.settings.startText}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }